import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { useState, type ChangeEvent, type FC } from 'react';

export const FeedbackModal: FC<{
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (comment: string) => void;
}> = ({ isOpen, onOpenChange, onConfirm }) => {
  const [comment, setComment] = useState('');

  const handleCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value);
  };

  const handleConfirm = () => {
    onConfirm(comment);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>What was wrong with the answer?</DialogTitle>
          <DialogDescription>
            Please provide feedback to help us improve our AI.
          </DialogDescription>
        </DialogHeader>
        <Textarea value={comment} onChange={handleCommentChange} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button onClick={handleConfirm}>Send feedback</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
